/* eslint-disable indent */

    var Slider = require('../../modules/ui/slider');
    var trackingUtils = require('../../modules/utils/tracking.utils');
    var filterModelMixin = require('./utils/filter.model.mixin');
    var filterViewMixin = require('./utils/filter.view.mixin');
    var filterMixin = require('./utils/filter.mixin.js');
    var tripTypeUtils = require('../../modules/utils/trip_type');
    var templateSelectorsViewMixin = require('./utils/template_selector.view.mixin');
    var TimeBudgetView = require('../time_budget/view');
    var TimeBudgetModel = require('../time_budget/model');
    var nestedViewMixin = require('../../modules/views/nested_view');
    var currentSearchSingletonModel = require('../../modules/models/current_search.singleton.model');
    var HALF_HOUR_IN_MILLISECONDS = 30 * 60 * 1000;
    var ONE_HOUR_IN_MILLISECONDS = 60 * 60 * 1000;
    var UTC_HOUR_MINUTE_FORMAT = 'UTC:HH:MM';
    var SELECTED_DEPARTURE_PROPS = [
        'selectedMinDepartureDate',
        'selectedMaxDepartureDate',
    ];
    var getHourSelected = function(current, value) {
        var currentVal = !Odigeo._.isUndefined(current.position) ? this.slider.positionToSteppedVal(current.position) : value;
        var date = new Date(currentVal);
        return date.getUTCHours();
    };
    var setSelectedHour = function(fieldName, current, value) {
        this.model.get('budget').set(fieldName, getHourSelected.call(this, current, value));
    };
    var setMinSelectedHour = Odigeo._.partial(setSelectedHour, 'minSelectedHour');
    var setMaxSelectedHour = Odigeo._.partial(setSelectedHour, 'maxSelectedHour');
    var updateSelectedDates = function(model, values) {
        var selectedDates = Odigeo._.reduce(SELECTED_DEPARTURE_PROPS, function(memo, prop, index) {
            memo[prop] = values[index];
            return memo;
        }, {});
        model.set(selectedDates);
    };
    var updateLastChangedDate = function(model, values) {
        var lastChangedDate = Odigeo._.find(SELECTED_DEPARTURE_PROPS, function(prop, index) {
            return model.get(prop) !== values[index];
        });
        model.set('lastChangedDate', lastChangedDate);
    };
    var formatDate = Odigeo.Utils.formatDate;
    var formatTimeFilterDates = function(minDate, maxDate) {
        return formatDate(parseFloat(minDate), UTC_HOUR_MINUTE_FORMAT, true) + ' - ' + formatDate(parseFloat(maxDate), UTC_HOUR_MINUTE_FORMAT, true);
    };

    var createTimeBudget = function() {
        return new TimeBudgetView({
            el: '#' + this.widget.id + ' .time_budget',
            template: this.templates.budgetHistogram,
            model: this.model.get('budget'),
        });
    };

    Odigeo.defineWidget('time_filter', Odigeo.Widget.extend(Odigeo._.defaults({
        modelClass: Odigeo.Model.extend(Odigeo._.defaults({
            getRequestModel: function() {
                return {
                    minArrivalDate: this.get('selectedMinArrivalDate'),
                    maxArrivalDate: this.get('selectedMaxArrivalDate'),
                    minDepartureDate: this.get('selectedMinDepartureDate'),
                    maxDepartureDate: this.get('selectedMaxDepartureDate'),
                };
            },
            getBoundaryDates: function(data) {
                var range = {
                    min: data.boundaryMinDepartureDate,
                    max: data.boundaryMaxDepartureDate,
                };
                var minDate;
                var maxDate;

                if (this.widget.isTimeBudgetScope()) {
                    minDate = new Date(range.min);
                    maxDate = new Date(range.max);
                    minDate.setUTCHours('00');
                    minDate.setUTCMinutes('00');
                    maxDate.setUTCHours('23');
                    maxDate.setUTCMinutes('59');
                    range.min = minDate.getTime();
                    range.max = maxDate.getTime();
                }
                return range;
            },
            getRangeValues: function() {
                return [
                    this.get('selectedMinDepartureDate'),
                    this.get('selectedMaxDepartureDate'),
                ];
            },
            isFilterApplied: function() {
                var minSelectedDate = this.get('selectedMinDepartureDate');
                var maxSelectedDate = this.get('selectedMaxDepartureDate');
                var settedSelectedDated = Odigeo._.isNumber(minSelectedDate) && Odigeo._.isNumber(maxSelectedDate);
                return settedSelectedDated && (minSelectedDate !== this.get('boundaryMinDepartureDate') ||
                    maxSelectedDate !== this.get('boundaryMaxDepartureDate'));
            },
            getTagInfo: function() {
                var minDepartureTimeDate = formatDate(parseFloat(this.get('selectedMinDepartureDate')), UTC_HOUR_MINUTE_FORMAT, true);
                var maxDepartureTimeDate = formatDate(parseFloat(this.get('selectedMaxDepartureDate')), UTC_HOUR_MINUTE_FORMAT, true);
                return {
                    minDepartureDate: minDepartureTimeDate,
                    maxDepartureDate: maxDepartureTimeDate,
                };
            },
            initModel: function(data) {
                var range = this.getBoundaryDates(data);
                var model = Odigeo._.defaults({
                    averagePrice: data.averagePrice,
                    boundaryMinDepartureDate: range.min,
                    boundaryMaxDepartureDate: range.max,
                    selectedMinDepartureDate: range.min,
                    selectedMaxDepartureDate: range.max,
                    idx: this.widget.options.idx,
                }, Odigeo._.omit(data, 'budget'));
                this.set(model);
                this.get('budget').initModel(data.budget);
            },
            toJSON: function() {
                var data = Backbone.Model.prototype.toJSON.call(this);
                return Odigeo._.extend(data, {
                    budget: data.budget.toJSON(),
                });
            },
        }, filterModelMixin)),

        viewClass: Odigeo.View.extend(Odigeo._.defaults({
            selectors: {
                sliderContainer: '.timefilters_slider_container',
                departureDayLabel: '.departure_date_title',
                selectLabel: '.time_filter_date_title',
                header: '.time_filter_header',
            },

            initSlider: function() {
                const values = this.model.getRangeValues();
                const range = {
                    min: values[0],
                    max: values[1],
                };
                const isTimeBudgetScope = this.widget.isTimeBudgetScope();

                this.slider = new Slider(this.$cachedSelectors.sliderContainer, {
                    range: range,
                    values: values,
                    unit: 'h',
                    showValuesInRange: true,
                    formatter: Odigeo._.bind(this.getFormattedSlider, this),
                    stepRange: isTimeBudgetScope ? ONE_HOUR_IN_MILLISECONDS : HALF_HOUR_IN_MILLISECONDS,
                    styleClass: isTimeBudgetScope ?
                        'od-ui-slider-label-on-bottom od-time-slider' :
                        'od-ui-spaced-slider od-ui-slider-label-on-top',
                    reversed: this.widget.options.direction === 'rtl',
                });
                this.listenTo(this.slider, 'slider:change', this.notifyChange);
                if (isTimeBudgetScope) {
                    this.bindSliderHandlerEvents();
                }
                if (this.widget.options.initSelectLabel) {
                    this.updateSelectedLabel(values);
                    this.slider.refresh({showValuesInRange: false});
                    if (this.widget.options.updateSelectLabel) {
                        this.listenTo(this.slider, 'slider:move', this.updateSelectedLabel);
                    }
                }
            },
            refreshSlider: function() {
                if (!this.slider) {
                    this.initSlider();
                }
                this.slider.refresh({
                    values: this.model.getRangeValues(),
                });
            },
            bindSliderHandlerEvents: function() {
                var model = this.model;
                var handlers = this.slider.handlers;
                var sliderHandlerMoveEvent = 'sliderHandler:move';

                this.listenTo(handlers[0], sliderHandlerMoveEvent, setMinSelectedHour);
                this.listenTo(handlers[1], sliderHandlerMoveEvent, setMaxSelectedHour);
                this.listenTo(model, 'change:selectedMinDepartureDate', setMinSelectedHour);
                this.listenTo(model, 'change:selectedMaxDepartureDate', setMaxSelectedHour);
            },
            updateSelectedLabel: function(values) {
                this.$cachedSelectors.selectLabel.html(formatTimeFilterDates(values[0], values[1], this.widget.options));
            },
            notifyChange: function(values) {
                updateLastChangedDate(this.model, values);
                updateSelectedDates(this.model, values);
                this.model.doFilterRequest();
                this.sliderChangeTracking(values);
            },
            sliderChangeTracking: function(values) {
                var tripType = currentSearchSingletonModel.getInstance().get('type');
                var idxLabel = this.model.get('idx') + 1;
                var usedFilter = {'selectedMinDepartureDate': 'L', 'selectedMaxDepartureDate': 'R'};
                var tripTypeLetter = tripTypeUtils.toTinyAcronym(tripType);
                var trackingLabel = 'hours_' + idxLabel + tripTypeLetter + '_' + usedFilter[this.model.get('lastChangedDate')] + '_' +
                    Odigeo._.map(values, function(value) {
                        return new Date(Number(value)).getUTCHours();
                    }).join('_');

                trackingUtils.trackEvent('results_filters', trackingLabel);
            },
            getFormattedSlider: function(value) {
                return !Odigeo._.isNaN(value) && Odigeo._.isNumber(value) ? this.getFormattedDate(value) : value;
            },
            getFormattedDate: function(value) {
                return Odigeo.Utils.formatDate(new Date(value), 'hourMinutes', true);
            },

            restoreFilterStatus: function(fMetadata) {
                if (fMetadata.selectedMinDepartureDate > fMetadata.boundaryMinDepartureDate) {
                    this.model.set('selectedMinDepartureDate', fMetadata.selectedMinDepartureDate);
                } else {
                    this.model.set('selectedMinDepartureDate', this.model.get('boundaryMinDepartureDate'));
                }
                if (fMetadata.selectedMaxDepartureDate < fMetadata.boundaryMaxDepartureDate) {
                    this.model.set('selectedMaxDepartureDate', fMetadata.selectedMaxDepartureDate);
                } else {
                    this.model.set('selectedMaxDepartureDate', this.model.get('boundaryMaxDepartureDate'));
                }
            },

            updateFilter: function(idx, fMetadata, isActiveLeg, isRestoringStatus) {
                if (!isActiveLeg) {
                    this.model.initModel(fMetadata);
                }
                if (this.widget.options.tests.isFloatingFiltersEnabled && isRestoringStatus) {
                    this.restoreFilterStatus(fMetadata);
                }
                this.refreshSlider();
                if (this.widget.options.initSelectLabel) {
                    this.updateSelectedLabel(this.model.getRangeValues());
                }
                this.setIsFiltered(fMetadata);
            },

            resetFilter: function() {
                var data = this.model.toJSON();
                this.model.initModel(data);
                this.initFilter();
                this.model.doFilterRequest();
            },

            renderHeader: function() {
                var widget = this.widget;
                const templateData = Odigeo._.extend({}, widget.options.translations, {
                    idx: widget.options.idx,
                });
                this.$cachedSelectors.header.html(this.templates.header(templateData));
            },

            renderTimeBudget: function() {
                var widget = this.widget;
                if (widget.isTimeBudgetScope()) {
                    this.createView('budget', createTimeBudget.call(this));
                }
            },

            initFilter: function() {
                if (this.corrupted || this.start) {
                    this.renderHeader();
                    this.refreshSlider();
                    this.renderTimeBudget();
                    this.corrupted = false;
                    this.start = false;
                }
                this.initSlider();
                this.setIsFiltered(this.model.toJSON());
            },

            setIsFiltered: function(fMetadata) {
                var selectedMinDate = fMetadata.selectedMinDepartureDate;
                var selectedMaxDate = fMetadata.selectedMaxDepartureDate;
                var boundaryMinDate = fMetadata.boundaryMinDepartureDate;
                var boundaryMaxDate = fMetadata.boundaryMaxDepartureDate;
                var isFilterAvailable = selectedMinDate < selectedMaxDate;
                var result = isFilterAvailable && selectedMinDate !== boundaryMinDate || selectedMaxDate !== boundaryMaxDate;
                Odigeo.trigger(this.widget.widgetType + ':filtersUpdated', this.model.get('idx'), 'time_filter', result);
            },

            buildTemplates: function() {
                this.templates = Odigeo.Utils.getTemplates($('#filters-manager'), {
                    header: '.time_filter_header_template',
                    budgetHistogram: '.budget_histogram_template',
                });
            },
        }, templateSelectorsViewMixin, filterViewMixin, nestedViewMixin)),

        bindEvents: function() {
            this.listenTo(this.model, 'change:selectedMinDepartureDate', this.triggerFilterChange);
            this.listenTo(this.model, 'change:selectedMaxDepartureDate', this.triggerFilterChange);
        },

        init: function() {
            this.buildOptions();
            this.view.start = true;
            this.view.buildTemplates();
            this.model.set('budget', new TimeBudgetModel());
            var functionWrapper = this.isTimeBudgetScope() ?
                Odigeo._.partial(Odigeo._.throttle, _, 1000) :
                Odigeo._.partial(Odigeo._.iteratee, _, this);
            this.model.doFilterRequest = functionWrapper(Odigeo._.bind(this.model.filterRequest, this.model, ['time']));
            this.bindEvents();
        },

        rebuildWidgetIfNeeded: function() {
            var idx = this.getIndex();
            var view = this.view;
            var $el = this.view.getElement();
            view.corrupted = this.isCorrupted($el, idx);
            if (view.corrupted) {
                this.reinit($el, idx);
            }
        },

        isTimeBudgetScope: function() {
            const tripType = currentSearchSingletonModel.getInstance().get('type');
            return tripTypeUtils.isOneWayOrRoundTrip(tripType);
        },

        updateSlider: function() {
            this.view.slider.updateHandlers();
        },

        filterType: 'time',
    }, filterMixin)));
